import React, { useEffect, useState } from "react";
import { Label, FormFeedback, Button } from "reactstrap";
import { Icon } from "../../../components/Component";
import { Modal, ModalBody} from "reactstrap";
import ConfirmModal from "../modals/ConfirmModal";
import { RxCross2 } from "react-icons/rx";

import {
 
  Col,
 
  
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";





const MyImageUploadRHF = ({
   handleImageClose = () => {}, 
  name = "image_file",
  imageUrlName = "image",
  label = "Upload Image",
  register,
  setValue,
  watch,
  trigger,
  clearErrors,
  errors,
  required = false,
  size = 2048, // KB
}) => {
  const imageFile = watch(name);
  const imageUrl = watch(imageUrlName);
  const [preview, setPreview] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);


  /* Generate preview */
  useEffect(() => {
    if (imageFile instanceof File) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(imageFile);
    } else if (typeof imageUrl === "string") {
      setPreview(imageUrl);
    } else {
      setPreview(null);
    }
  }, [imageFile, imageUrl]);

  /* Handle file select */
  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Size validation
    if (file.size / 1024 > size) {
      setValue(name, null);
      setValue(imageUrlName, null);
      return;
    }

    setValue(name, file, { shouldValidate: true });
    setValue(imageUrlName, URL.createObjectURL(file));
    clearErrors?.(name);
    await trigger(name);
  };

  /* Remove image */
  const handleRemove = () => {
    setValue(name, null);
    setValue(imageUrlName, null);

    const input = document.getElementById(name);
    if (input) input.value = "";
  };

  return (
    <div className="form-group">
      <Label className="form-label">
        {label} {required && <span className="text-danger">*</span>}
      </Label>

      {!preview && (
        <input
          type="file"
          accept="image/*"
          id={name}
          className={`form-control ${errors?.[name] ? "is-invalid" : ""}`}
          {...register(name, {
            required: required ? `${label} is required` : false,
          })}
          onChange={handleChange}
        />
      )}

      {errors?.[name] && (
        <FormFeedback>{errors[name]?.message}</FormFeedback>
      )}

      {preview && (
        <div className="d-flex align-items-center mt-2 gap-2">
          <img
            src={preview}
            alt="preview"
            onClick={() => setPreviewOpen(true)}
            style={{
              maxWidth: "87px",
              maxHeight: "54px",
              marginLeft: "20px",
              objectFit: "cover",
              padding: "4px",
              marginTop: "32px",
              cursor: "pointer",
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
          />
          {/* <Modal
            isOpen={previewOpen}
            toggle={() => setPreviewOpen(false)}
            centered
          >
            <ModalBody className="text-center">
              <img
                src={preview}
                alt="full-preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            </ModalBody>
          </Modal> */}
   

           <Modal
  isOpen={previewOpen}
  toggle={() => setPreviewOpen(false)}
  centered
  size="lg"
  modalClassName="zoom"
>
  <ModalHeader
    toggle={() => setPreviewOpen(false)}
    close={
      <button
        type="button"
        className="close"
        onClick={() => setPreviewOpen(false)}
      >
        <RxCross2 />
      </button>
    }
  />

  <ModalBody>
    <Row className="container-xl">
      <Col md="12">
        <div className="d-flex justify-content-center align-items-center">
          <img
            src={preview}
            alt="preview-image"
            style={{ width: "50%", height: "auto" }}
          />
        </div>
      </Col>
    </Row>
  </ModalBody>

  <ModalFooter>
    <Button
      color="danger"
      size="md"
      onClick={() => setPreviewOpen(false)}
    >
      Close
    </Button>
  </ModalFooter>
</Modal>




          <Button
            type="button"

            size="xs"

            onClick={handleRemove}
            style={{
              marginBottom: "27px",
              marginLeft: "-87px",
              color: "crimson",
              backgroundColor: "transparent",
              border: "none",
              boxShadow: "none",
              cursor: "pointer",
            }}
          >
            <Icon name="trash" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default MyImageUploadRHF;
